import AccountClient from './AccountClient';
import LoginClient from './LoginClient';
import CommonClient from './CommonClient';
import AgencyClient from './AgencyClient';
import StudentClient from './StudentClient';
import RegistrationClient from './RegistrationClient';
import AdvertisingClient from './AdvertisingClient';
import DistributionClinent from './DistributionClinent';
import PointsClient from './PointsClient';
import CounselorClient from './CounselorClient';
import ConfigClient from './ConfigClient';
import CourseClient from './CourseClient';
import TestClient from './TestClient';
import CertClient from './CertClient';
import OrderClient from './OrderClient';
import LiveClient from './LiveClient';
import StatisticsClient from './StatisticsClient';
import EvaluationClient from './EvaluationClient';
import CouponClient from './CouponClient';
import AgentClient from './AgentClient';
import Client from './Client';

class AxClient {
    client = Client;

    account = new AccountClient();

    login = new LoginClient();

    common = new CommonClient();

    agency = new AgencyClient();

    student = new StudentClient();

    registration = new RegistrationClient();

    advertising = new AdvertisingClient();

    distribution = new DistributionClinent();

    points = new PointsClient();

    counselor = new CounselorClient();

    config = new ConfigClient();

    course = new CourseClient();

    test = new TestClient();

    cert = new CertClient();

    order = new OrderClient();

    live = new LiveClient();

    statistics = new StatisticsClient();

    evaluation = new EvaluationClient();

    coupon = new CouponClient();

    agent = new AgentClient();
}

export default new AxClient();
